import api from "./api";

const JUNK = /[\s\u200b-\u200f\u202a-\u202e\u2066-\u2069\ufeff\u00a0]/g;
const DIGITS = { "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4", "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9", "＠": "@", "．": "." };

export const cleanEmail = (v) =>
  String(v || "").replace(/[٠-٩＠．]/g, (c) => DIGITS[c]).replace(JUNK, "").toLowerCase();

export const isEmail = (v) => /^[^@\s]+@[^@\s]+\.[a-z]{2,}$/.test(v);

// Returns null on success, or an error translation key.
export const subscribeEmail = async (raw, lang, product) => {
  const email = cleanEmail(raw);
  if (!isEmail(email)) return "newsletter_error";
  try {
    await api.post("/newsletter", { email, lang, product: product || undefined }, { timeout: 15000 });
    return null;
  } catch (err) {
    if (err.response?.status === 429) return "err_too_many";
    if (err.response?.status === 400) return "newsletter_error";
    return "err_network";
  }
};
